<template>
  <div>
    <div class="panel panel-default">
      <div class="panel-heading">Отзывы</div>

      <div class="panel-body">

        <div class="loader" v-show="!loaded"></div>

        <div class="row" v-show="loaded">
          <div class="col-md-8">

          </div>
          <div class="col-md-4">
            <button class="btn btn-default pull-right" type="submit" @click="add()">
              Добавить
            </button>
          </div>
        </div>

        <table class="table" v-show="loaded">
          <thead>
          <tr>
            <th>#</th>
            <th>Фото</th>
            <th>Имя</th>
            <th width="300">Отзыв</th>
            <th>Сортировка</th>
            <th>Показ на сайте</th>
            <th class="text-right">Действие</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="item in list">
            <td>{{item.id}}</td>
            <td><img :src="url+item.image" width="60" alt=""></td>
            <td>{{item.name}}</td>
            <td>{{item.review_text}}</td>
            <td>{{item.sort}}</td>
            <td>{{item.visible ? 'Да' : 'Нет'}}</td>
            <td>
              <button type="button" class="btn btn-default btn-sm pull-right" @click="edit(item)"><span class="glyphicon glyphicon-edit"></span></button>
              <button type="button" class="btn btn-default btn-sm pull-right" @click="del(item.id, item.name)"><span class="glyphicon glyphicon-trash"></span></button>
            </td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>

    <modal v-model="modalShow" title="Отзыв" @hide="modalHide()" @before-close="beforeClose">
      <!--error-->
      <div class="alert alert-danger fade in" v-show="modalError">
        <p>{{modalError}}</p>
      </div>

      <!--form-->
      <form name="modal-form" id="modal-form">
        <div class="form-group">
          <label for="image">Изображение</label>
          <div class="image-wrap" :style="{backgroundImage: 'url('+url+modalData.image+')'}">
            <span v-show="!modalData.image">Изображение отсутствует</span>
          </div>
          <input type="file" id="image">
          <p class="help-block">Выберите изображение для загрузки (120x120 jpg,png)</p>
        </div>
        <div class="form-group">
          <label for="name" class="control-label">Имя:</label>
          <input class="form-control" id="name" v-model="modalData.name">
        </div>
        <div class="form-group">
          <label for="review-text" class="control-label">Отзыв:</label>
          <textarea class="form-control" rows="10" id="review-text" v-model="modalData.review_text"></textarea>
        </div>
        <div class="form-group">
          <label for="sort" class="control-label">Сортировка:</label>
          <input class="form-control" id="sort" v-model="modalData.sort">
        </div>
        <div class="checkbox" style="margin-top:35px;">
          <label>
            <input type="checkbox" v-model="modalData.visible">
            Включить показ на сайте
          </label>
        </div>
      </form>

      <div slot="footer">
        <btn type="primary" class="pull-left" @click="store()">Сохранить</btn>
        <btn type="default" class="pull-left" @click="close()">Отмена</btn>
      </div>
    </modal>
  </div>
</template>

<script>
  import {api} from './http'
  var config = require('./config')

  export default {
    mounted () {
    },
    data () {
      return {
        modalShow: false,
        modalData: {},
        modalError: '',
        categories: [],
        loaded: false,
        list: [],
        url: config.appUrl
      }
    },
    beforeCreate () {
      this.loaded = false
      api.post('reviews/list').then(response => {
        this.loaded = true
        this.list = response.data.items
      })
    },
    methods: {
      beforeClose () {
      },
      refreshList () {
        this.loaded = false
        api.post('reviews/list').then(response => {
          this.loaded = true
          this.list = response.data.items
        })
      },
      add () {
        this.modalShow = true
      },
      edit (item) {
        var copyItem = {}
        Object.assign(copyItem, item)
        this.modalShow = true
        this.modalData = copyItem
      },
      close () {
        this.resetForm()
        this.modalShow = false
        this.modalError = ''
        this.resetModal()
      },
      modalClose () {
        this.resetForm()
        this.modalShow = false
        this.modalError = ''
        this.resetModal()
      },
      modalHide () {
        this.modalClose()
      },
      resetForm () {
        var form = document.querySelector('#modal-form')
        form.reset()
      },
      store () {
        var formData = new FormData()
        for (let key in this.modalData) {
          if (Array.isArray(this.modalData[key])) {
            for (let i in this.modalData[key]) {
              formData.append(key + '[]', this.modalData[key][i])
            }
          } else {
            let val = this.modalData[key] || ''
            formData.append(key, val)
          }
        }

        if (document.querySelector('#image').files.length) {
          var file = document.querySelector('#image').files[0]
          formData.append('image', file)
        }

        api.post('reviews/store', formData).then(response => {
          if (response.data.success) {
            this.modalClose()
            this.refreshList()
          } else {
            this.modalError = response.data.message
          }
        })
      },
      del (id, name) {
        if (!confirm('Удалить отзыв "' + name + '"')) {
          return
        }
        var formData = new FormData()
        formData.append('id', id)

        api.post('reviews/delete', formData)
          .then(res => { this.refreshList() })
      },
      resetModal () {
        this.modalData = {}
      }
    }
  }
</script>

<style>
  .image-wrap {
    width: 370px;
    height: 248px;
    background-size: cover;
    border: 1px solid silver;
    display: flex;
    align-items: center;
    justify-content: center;
  }
</style>



// WEBPACK FOOTER //
// src/components/AdminReviews.vue